import { BlankSlate } from "@msuite/ui/blank-slate";
import { ContentBox } from "@msuite/ui/content-box";
import { Documents } from "@/components/documents";
import { LoadingScreen } from "@msuite/ui/loading-screen";
import { useTranslation } from "@msuite/ui/localization";
import { Tabs } from "@msuite/ui/tabs";
import { useParams } from "react-router";
import { useProtocol } from "@/hooks/use-protocol";
import { ProtocolCallRequest } from "./protocol-call-request";
import { ProtocolGeneral } from "./protocol-general";
import { ProtocolHeader } from "./protocol-header";
import { ProtocolMenu } from "./protocol-menu";
import { ProtocolRelated } from "./protocol-related";

export function Protocol() {
	/** Hooks */
	const { t } = useTranslation();
	const protocolId = useParams().protocolId as string;

	/** Query */
	const { protocol, isLoading, isError } = useProtocol(protocolId);

	/** Guard */
	if (isLoading) return <LoadingScreen />;
	if (isError || !protocol) return <BlankSlate label={t("protocols.protocol_not_loaded")} />;

	/** Render */
	return (
		<ContentBox bottomPadding="none">
			<ProtocolHeader protocolId={protocolId} />
			<Tabs
				header={() => <ProtocolMenu protocolId={protocolId} />}
				groups={[
					{
						name: "general",
						panels: [
							{
								label: t("general.general"),
								panel: () => <ProtocolGeneral protocolId={protocolId} />,
								cyId: "protocol-general-tab",
								errors: [],
							},
						],
					},
					{
						name: "information",
						panels: [
							protocol.type === "call-request"
								? {
										label: t("protocols.callback_log"),
										panel: () => <ProtocolCallRequest protocolId={protocolId} />,
										cyId: "protocol-call-request-tab",
										errors: [],
									}
								: null,
							{
								label: t("files.files"),
								panel: () => (
									<Documents
										documentFilesTable="protocolFiles"
										identifier={protocolId}
										parent={{ subject: "Protocol", resource: protocol }}
									/>
								),
								cyId: "protocol-files-tab",
								errors: [],
							},
							protocol.projectId
								? {
										label: t("protocols.related_protocols"),
										panel: () => (
											<ProtocolRelated
												protocolId={protocolId}
												projectId={protocol.projectId as string}
											/>
										),
										cyId: "protocol-related-tab",
										errors: [],
									}
								: null,
						],
					},
				]}
			/>
		</ContentBox>
	);
}
